import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);


const state = {
  years: [],
  varieties: [],
  locations: [],
  locationsAll: [],
  levels: [],
  samples: [],
  publicSamples: [],
  samplesByUser: [],
  winemakingNotes: [],
};

const mutations = {
  updateYears(theState, payload) {
    theState.years = payload;
  },
  updateVarieties(theState, payload) {
    theState.varieties = payload;
  },
  updateLocations(theState, payload) {
    theState.locations = payload;
  },
  updateLocationsAll(theState, payload) {
    theState.locationsAll = payload;
  },
  updateLevels(theState, payload) {
    theState.levels = payload;
  },
  updateSamples(theState, payload) {
    theState.samples = payload;
  },
  updateSamplesByUser(theState, payload) {
    theState.samplesByUser = payload;
  },
  updatePublicSamples(theState, payload) {
    theState.publicSamples = payload;
  },
  updateWinemakingNotes(theState, payload) {
    theState.winemakingNotes = payload;
  },
};

const actions = {
  getYears(context) {
    return axios
      .get('sample-years')
      .then((resp) => {
        context.commit('updateYears', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  getVarieties(context) {
    return axios
      .get('varieties')
      .then((resp) => {
        context.commit('updateVarieties', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  getLocations(context) {
    return axios
      .get('locations-public')
      .then((resp) => {
        context.commit('updateLocations', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  getLocationsAll(context) {
    return axios
      .get('locations')
      .then((resp) => {
        context.commit('updateLocationsAll', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  getLevels(context) {
    return axios
      .get('tannin-levels')
      .then((resp) => {
        context.commit('updateLevels', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  getSamples(context, payload) {
    return axios
      .get(`samples/${payload.location}/${payload.variety}/${payload.year}`)
      .then((resp) => {
        context.commit('updateSamples', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  getSamplesByUser(context, payload) {
    return axios
      .get(`samples-user/${payload.user_id}`)
      .then((resp) => {
        context.commit('updateSamplesByUser', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  getSamplesPublic(context) {
    return axios
      .get('samples-public')
      .then((resp) => {
        context.commit('updatePublicSamples', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  getWinemakingNotes(context, payload) {
    if (payload.var_id <= 0) return null;
    return axios
      .get(`winemaking-notes-variety/${payload.var_id}`)
      .then((resp) => {
        context.commit('updateWinemakingNotes', resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
};


export default new Vuex.Store({
  state,
  mutations,
  actions,
});



// WEBPACK FOOTER //
// ./src/store/index.js